export default __webpack_public_path__ + "static/media/CarImages.SportagGallery1.be83ae56.jpg";